export const columns = [
    {
        title: "Name",
        dataIndex: "name",
        key: "name",
        sorter: {
            compare: (a:any, b:any) => a.name.localeCompare(b.name),
        },
        defaultSortOrder: "ascend"
    },
    {
        title: "Items Looted",
        dataIndex: "itemsLooted",
        key: "itemsLooted",
        sorter: {
            compare: (a:any, b:any) => a.itemsLooted - b.itemsLooted,
        },
        sortDirections: "descend"
    },
    {
        title: "Bamboos Destroyed",
        dataIndex: "bambooDestroyed",
        key: "bambooDestroyed",
        sorter: {
            compare: (a:any, b:any) => a.itemsLooted - b.itemsLooted,
        },
        sortDirections: "descend"
    },
    {
        title: "Items Looted from Players",
        dataIndex: "playerItemsLooted",
        key: "playerItemsLooted",
        sorter: {
            compare: (a:any, b:any) => a.playerItemsLooted - b.playerItemsLooted,
        },
        sortDirections: "descend"
    },
    {
        title: "Vaults",
        dataIndex: "vaults",
        key: "vaults",
        sorter: {
            compare: (a:any, b:any) => a.vaults - b.vaults,
        },
        sortDirections: "descend"
    },
    {
        title: "Parachute Distance",
        dataIndex: "parachuteDistance",
        key: "parachute",
        sorter: {
            compare: (a:any, b:any) => a.parachuteDistance - b.parachuteDistance,
        },
        sortDirections: "descend",
        render: (parachuteDistance: number) => parachuteDistance.toFixed(2)
    },
    {
        title: "Health Healed",
        dataIndex: "healthHealed",
        key: "health",
        sorter: {
            compare: (a:any, b:any) => a.healthHealed - b.healthHealed,
        },
        sortDirections: "descend",
        render: (healthHealed: number) => healthHealed.toFixed(2)
    },
    {
        title: "Vehicle Damage",
        dataIndex: "vehicleDamage",
        key: "vehicleDamage",
        sorter: {
            compare: (a:any, b:any) => a.vehicleDamage - b.vehicleDamage,
        },
        sortDirections: "descend",
        render: (vehicleDamage: number) => vehicleDamage.toFixed(2)
    },
    {
        title: "Damage Dealt",
        dataIndex: "damageDealt",
        key: "damageDealt",
        sorter: {
            compare: (a:any, b:any) => a.damageDealt - b.damageDealt,
        },
        sortDirections: "descend",
        render: (damageDealt: number) => damageDealt.toFixed(2)
    },
    {
        title: "Damage Taken",
        dataIndex: "damageTaken",
        key: "damageTaken",
        sorter: {
            compare: (a:any, b:any) => a.damageTaken - b.damageTaken,
        },
        sortDirections: "descend",
        render: (damageTaken: number) => damageTaken.toFixed(2)
    },
    {
        title: "Tires Popped",
        dataIndex: "tiresPopped",
        key: "tiresPopped",
        sorter: {
            compare: (a:any, b:any) => a.tiresPopped - b.tiresPopped,
        },
        sortDirections: "descend"
    },
    {
        title: "Vests Destroyed",
        dataIndex: "vestsDestroyed",
        key: "vestsDestroyed",
        sorter: {
            compare: (a:any, b:any) => a.vestsDestroyed - b.vestsDestroyed,
        },
        sortDirections: "descend"
    },
    {
        title: "Doors Used",
        dataIndex: "doorsUsed",
        key: "doorsUsed",
        sorter: {
            compare: (a:any, b:any) => a.doorsUsed - b.doorsUsed,
        },
        sortDirections: "descend"
    },
    {
        title: "Windows Broken",
        dataIndex: "windowsDestroyed",
        key: "windowsDestroyed",
        sorter: {
            compare: (a:any, b:any) => a.windowsDestroyed - b.windowsDestroyed,
        },
        sortDirections: "descend"
    },
    {
        title: "Fences Broken",
        dataIndex: "fencesDestroyed",
        key: "fencesDestroyed",
        sorter: {
            compare: (a:any, b:any) => a.fencesDestroyed - b.fencesDestroyed,
        },
        sortDirections: "descend"
    },
    {
        title: "Air Drop Items Looted",
        dataIndex: "airDropItemsLooted",
        key: "airDropItemsLooted",
        sorter: {
            compare: (a:any, b:any) => a.airDropItemsLooted - b.airDropItemsLooted,
        },
        sortDirections: "descend"
    },
    {
        title: "Bandages Used",
        dataIndex: "bandagesUsed",
        key: "bandagesUsed",
        sorter: {
            compare: (a:any, b:any) => a.bandagesUsed - b.bandagesUsed,
        },
        sortDirections: "descend"
    },
    {
        title: "First Aids Used",
        dataIndex: "firstAidsUsed",
        key: "firstAidsUsed",
        sorter: {
            compare: (a:any, b:any) => a.firstAidsUsed - b.firstAidsUsed,
        },
        sortDirections: "descend"
    },
    {
        title: "Med Kits Used",
        dataIndex: "medKitsUsed",
        key: "medKitsUsed",
        sorter: {
            compare: (a:any, b:any) => a.medKitsUsed - b.medKitsUsed,
        },
        sortDirections: "descend"
    },
    {
        title: "Energy Drinks Used",
        dataIndex: "energyDrinksUsed",
        key: "energyDrinksUsed",
        sorter: {
            compare: (a:any, b:any) => a.energyDrinksUsed - b.energyDrinksUsed,
        },
        sortDirections: "descend"
    },
    {
        title: "Pain Killers Used",
        dataIndex: "painkillersUsed",
        key: "painkillersUsed",
        sorter: {
            compare: (a:any, b:any) => a.painkillersUsed - b.painkillersUsed,
        },
        sortDirections: "descend"
    },
    {
        title: "Adrenline Syringes Used",
        dataIndex: "adrenlineSyringesUsed",
        key: "adrenlineSyringesUsed",
        sorter: {
            compare: (a:any, b:any) => a.adrenlineSyringesUsed - b.adrenlineSyringesUsed,
        },
        sortDirections: "descend"
    },
    {
        title: "Emergency Pickups Used",
        dataIndex: "emergencyPickupsUsed",
        key: "emergencyPickupsUsed",
        sorter: {
            compare: (a:any, b:any) => a.emergencyPickupsUsed - b.emergencyPickupsUsed,
        },
        sortDirections: "descend"
    },
    {
        title: "Items Dropped",
        dataIndex: "itemsDropped",
        key: "itemsDropped",
        sorter: {
            compare: (a:any, b:any) => a.itemsDropped - b.itemsDropped,
        },
        sortDirections: "descend"
    },
    {
        title: "Bullets Fired (Rounded)",
        dataIndex: "bulletsFired",
        key: "bulletsFired",
        sorter: {
            compare: (a:any, b:any) => a.bulletsFired - b.bulletsFired,
        },
        sortDirections: "descend"
    },
    {
        title: "Gas Poured",
        dataIndex: "gasCansUsed",
        key: "gasCansUsed",
        sorter: {
            compare: (a:any, b:any) => a.gasCansUsed - b.gasCansUsed,
        },
        sortDirections: "descend"
    },
    {
        title: "Gas Can Trails Ignited",
        dataIndex: "fuelPuddlesIgnited",
        key: "fuelPuddlesIgnited",
        sorter: {
            compare: (a:any, b:any) => a.fuelPuddlesIgnited - b.fuelPuddlesIgnited,
        },
        sortDirections: "descend"
    },
    {
        title: "Smokes",
        dataIndex: "smokesThrown",
        key: "smokesThrown",
        sorter: {
            compare: (a:any, b:any) => a.smokesThrown - b.smokesThrown,
        },
        sortDirections: "descend"
    },
    {
        title: "Stuns",
        dataIndex: "flashbangsThrown",
        key: "flashbangsThrown",
        sorter: {
            compare: (a:any, b:any) => a.flashbangsThrown - b.flashbangsThrown,
        },
        sortDirections: "descend"
    },
    {
        title: "Mollies Thrown",
        dataIndex: "molotovsThrown",
        key: "molotovsThrown",
        sorter: {
            compare: (a:any, b:any) => a.molotovsThrown - b.molotovsThrown,
        },
        sortDirections: "descend"
    },
    {
        title: "Nades Thrown",
        dataIndex: "nadesThrown",
        key: "nadesThrown",
        sorter: {
            compare: (a:any, b:any) => a.nadesThrown - b.nadesThrown,
        },
        sortDirections: "descend"
    },
    {
        title: "Throwables Thrown",
        dataIndex: "throwablesThrown",
        key: "throwablesThrown",
        sorter: {
            compare: (a:any, b:any) => a.throwablesThrown - b.throwablesThrown,
        },
        sortDirections: "descend"
    },
    {
        title: "Headshot Kills",
        dataIndex: "headshotKills",
        key: "headshotKills",
        sorter: {
            compare: (a:any, b:any) => a.headshotKills - b.headshotKills,
        },
        sortDirections: "descend"
    },
    {
        title: "Torso Kills",
        dataIndex: "torsoKills",
        key: "torsoKills",
        sorter: {
            compare: (a:any, b:any) => a.torsoKills - b.torsoKills,
        },
        sortDirections: "descend"
    },
    {
        title: "Pelvis Kills",
        dataIndex: "pelvisKills",
        key: "pelvisKills",
        sorter: {
            compare: (a:any, b:any) => a.pelvisKills - b.pelvisKills,
        },
        sortDirections: "descend"
    },
    {
        title: "Arm Kills",
        dataIndex: "armKills",
        key: "armKills",
        sorter: {
            compare: (a:any, b:any) => a.armKills - b.armKills,
        },
        sortDirections: "descend"
    },
    {
        title: "Leg Kills",
        dataIndex: "legKills",
        key: "legKills",
        sorter: {
            compare: (a:any, b:any) => a.legKills - b.legKills,
        },
        sortDirections: "descend"
    },
    {
        title: "Nade Kills",
        dataIndex: "nadeKills",
        key: "nadeKills",
        sorter: {
            compare: (a:any, b:any) => a.nadeKills - b.nadeKills,
        },
        sortDirections: "descend"
    },
    {
        title: "Molotov Kills",
        dataIndex: "molotovKills",
        key: "molotovKills",
        sorter: {
            compare: (a:any, b:any) => a.molotovKills - b.molotovKills,
        },
        sortDirections: "descend"
    },
    {
        title: "C4 Kills",
        dataIndex: "c4Kills",
        key: "c4Kills",
        sorter: {
            compare: (a:any, b:any) => a.c4Kills - b.c4Kills,
        },
        sortDirections: "descend"
    },
    {
        title: "Wallbang Kills",
        dataIndex: "wallbangKills",
        key: "wallbangKills",
        sorter: {
            compare: (a:any, b:any) => a.wallbangKills - b.wallbangKills,
        },
        sortDirections: "descend"
    },
    {
        title: "Suicides",
        dataIndex: "suicides",
        key: "suicides",
        sorter: {
            compare: (a:any, b:any) => a.suicides - b.suicides,
        },
        sortDirections: "descend"
    },
    {
        title: "Total Boosts",
        dataIndex: "boosts",
        key: "boosts",
        sorter: {
            compare: (a:any, b:any) => a.boosts - b.boosts,
        },
        sortDirections: "descend"
    },
    {
        title: "Heals",
        dataIndex: "heals",
        key: "heals",
        sorter: {
            compare: (a:any, b:any) => a.heals - b.heals,
        },
        sortDirections: "descend"
    },
    {
        title: "Knocks",
        dataIndex: "DBNOs",
        key: "DBNOs",
        sorter: {
            compare: (a:any, b:any) => a.DBNOs - b.DBNOs,
        },
        sortDirections: "descend"
    },
    {
        title: "Kills",
        dataIndex: "kills",
        key: "kills",
        sorter: {
            compare: (a:any, b:any) => a.kills - b.kills,
        },
        sortDirections: "descend"
    },
    {
        title: "Assists",
        dataIndex: "assists",
        key: "assists",
        sorter: {
            compare: (a:any, b:any) => a.assists - b.assists,
        },
        sortDirections: "descend"
    },
    {
        title: "Revives",
        dataIndex: "revives",
        key: "revives",
        sorter: {
            compare: (a:any, b:any) => a.revives - b.revives,
        },
        sortDirections: "descend"
    },
    {
        title: "Walk Distance",
        dataIndex: "walkDistance",
        key: "walkDistance",
        sorter: {
            compare: (a:any, b:any) => a.walkDistance - b.walkDistance,
        },
        sortDirections: "descend",
        render: (walkDistance: number) => emptyCheckNumberFormat(walkDistance)
    },
    {
        title: "Ride Distance",
        dataIndex: "rideDistance",
        key: "rideDistance",
        sorter: {
            compare: (a:any, b:any) => a.rideDistance - b.rideDistance,
        },
        sortDirections: "descend",
        render: (rideDistance: number) => emptyCheckNumberFormat(rideDistance)
    },
    {
        title: "Swim Distance",
        dataIndex: "swimDistance",
        key: "swimDistance",
        sorter: {
            compare: (a:any, b:any) => a.swimDistance - b.swimDistance,
        },
        sortDirections: "descend",
        render: (swimDistance: number) => emptyCheckNumberFormat(swimDistance)
    },
    {
        title: "Gold Sold",
        dataIndex: "goldSold",
        key: "goldSold",
        sorter: {
            compare: (a:any, b:any) => a.goldSold - b.goldSold,
        },
        sortDirections: "descend",
        render: (goldSold: number) => emptyCheckNumberFormat(goldSold)
    },
    {
        title: "EV Charger Destroyed",
        dataIndex: "evChargerDestroyed",
        key: "evChargerDestroyed",
        sorter: {
            compare: (a:any, b:any) => a.evChargerDestroyed - b.evChargerDestroyed,
        },
        sortDirections: "descend",
        render: (evChargerDestroyed: number) => emptyCheckNumberFormat(evChargerDestroyed)
    },
    {
        title: "Jukebox Used",
        dataIndex: "jukeboxUsed",
        key: "jukeboxUsed",
        sorter: {
            compare: (a:any, b:any) => a.jukeboxUsed - b.jukeboxUsed,
        },
        sortDirections: "descend",
        render: (jukeboxUsed: number) => emptyCheckNumberFormat(jukeboxUsed)
    },
    {
        title: "Safes Opened",
        dataIndex: "safeOpened",
        key: "safeOpened",
        sorter: {
            compare: (a:any, b:any) => a.safeOpened - b.safeOpened,
        },
        sortDirections: "descend",
        render: (safeOpened: number) => emptyCheckNumberFormat(safeOpened)
    },
    {
        title: "C4s Thrown",
        dataIndex: "c4sThrown",
        key: "c4sThrown",
        sorter: {
            compare: (a:any, b:any) => a.c4sThrown - b.c4sThrown,
        },
        sortDirections: "descend",
        render: (c4sThrown: number) => emptyCheckNumberFormat(c4sThrown)
    },
    {
        title: "Emergency Covers Thrown",
        dataIndex: "eCoversThrown",
        key: "eCoversThrown",
        sorter: {
            compare: (a:any, b:any) => a.eCoversThrown - b.eCoversThrown,
        },
        sortDirections: "descend",
        render: (eCoversThrown: number) => emptyCheckNumberFormat(eCoversThrown)
    },
    {
        title: "Carry Time (s)",
        dataIndex: "carryTime",
        key: "carryTime",
        sorter: {
            compare: (a:any, b:any) => a.carryTime - b.carryTime,
        },
        sortDirections: "descend",
        render: (carryTime: number) => emptyCheckNumberFormat(carryTime)
    },
    {
        title: "Carry Time Teammate (s)",
        dataIndex: "carryTimeTeammate",
        key: "carryTimeTeammate",
        sorter: {
            compare: (a:any, b:any) => a.carryTimeTeammate - b.carryTimeTeammate,
        },
        sortDirections: "descend",
        render: (carryTimeTeammate: number) => emptyCheckNumberFormat(carryTimeTeammate)
    },
    {
        title: "Carry Time Enemy (s)",
        dataIndex: "carryTimeEnemy",
        key: "carryTimeEnemy",
        sorter: {
            compare: (a:any, b:any) => a.carryTimeEnemy - b.carryTimeEnemy,
        },
        sortDirections: "descend",
        render: (carryTimeEnemy: number) => emptyCheckNumberFormat(carryTimeEnemy)
    },
    {
        title: "Carried Time (s)",
        dataIndex: "carriedTime",
        key: "carriedTime",
        sorter: {
            compare: (a:any, b:any) => a.carriedTime - b.carriedTime,
        },
        sortDirections: "descend",
        render: (carriedTime: number) => emptyCheckNumberFormat(carriedTime)
    },
    {
        title: "Carried Time Teammate (s)",
        dataIndex: "carriedTimeTeammate",
        key: "carriedTimeTeammate",
        sorter: {
            compare: (a:any, b:any) => a.carriedTimeTeammate - b.carriedTimeTeammate,
        },
        sortDirections: "descend",
        render: (carriedTimeTeammate: number) => emptyCheckNumberFormat(carriedTimeTeammate)
    },
    {
        title: "Carried Time Enemy (s)",
        dataIndex: "carriedTimeEnemy",
        key: "carriedTimeEnemy",
        sorter: {
            compare: (a:any, b:any) => a.carriedTimeEnemy - b.carriedTimeEnemy,
        },
        sortDirections: "descend",
        render: (carriedTimeEnemy: number) => emptyCheckNumberFormat(carriedTimeEnemy)
    }
]

function emptyCheckNumberFormat(field: number) {
    if (field === null || field === undefined) {
        return 0.00
    } else {
        return field.toFixed(2)
    }
}